import { register } from "./registry";
import { getSyncCalendar, loadCalendar, toAd, todayBs, fmt } from "./calendar";
import { moveFocus } from "./keyboard";
import { mask, parseMiti, type Pattern } from "./miti-core";

let cachedCal: any = getSyncCalendar();

register((root) => {
  const inputs = root.querySelectorAll<HTMLInputElement>("input[data-kit-miti]");
  if (inputs.length > 0 && !cachedCal) void loadCalendar().then((c) => { cachedCal = c; });
  inputs.forEach((input) => {
    if (input.dataset.kitBound === "1") return;
    input.dataset.kitBound = "1";
    input.dataset.kitOwnsEnter = "1";
    const pattern = (input.dataset.kitPattern as Pattern) ?? (document.body.dataset.kitPattern as Pattern) ?? "YMD";
    const hint = document.createElement("span"); hint.className = "miti-ad"; input.after(hint);
    const err = document.createElement("span"); err.className = "field-error"; err.hidden = true; hint.after(err);
    if (!input.form?.querySelector("input[name='date_input_kind']")) {
      const kind = document.createElement("input"); kind.type = "hidden"; kind.name = "date_input_kind"; kind.value = "bs";
      input.form?.appendChild(kind);
    }
    const updateAd = async () => {
      const cal = cachedCal ?? await loadCalendar();
      cachedCal = cal;
      const r = parseMiti(input.value, todayBs(), pattern, cal);
      if (!r.error && r.value) {
        const [y, m, d] = r.value.split("-").map(Number);
        hint.textContent = `= ${toAd(cal, { y: y!, m: m!, d: d! })}`;
      }
    };
    if (input.value) void updateAd();
    input.addEventListener("input", () => {
      if (/^\d+$/.test(input.value.replace(/-/g, ""))) {
        input.value = mask(input.value, pattern);
        if (input.value.length >= 10) void updateAd();
      }
    });
    input.addEventListener("keydown", (e: KeyboardEvent) => {
      if (e.key !== "Enter" && e.key !== "Tab") return;
      e.preventDefault();
      if (e.shiftKey) { moveFocus(input, -1); return; }
      // An optional date left blank moves on (Cheque Miti with no cheque, Supplier Bill Miti, Due Miti: spec Req = N).
      // The document's own Miti and fields marked required still stop on blank.
      const required = input.required || input.getAttribute("aria-required") === "true" || /^(form\.)?miti$/i.test(input.name);
      if (!input.value.trim() && !required) {
        input.removeAttribute("aria-invalid"); err.hidden = true; hint.textContent = "";
        moveFocus(input, 1);
        return;
      }
      const cal = cachedCal ?? getSyncCalendar();
      if (cal) {
        cachedCal = cal;
        const r = parseMiti(input.value, todayBs(), pattern, cal);
        if (r.error) {
          input.setAttribute("aria-invalid", "true"); err.textContent = r.error; err.hidden = false; input.select();
          return;
        }
        input.value = r.value!; input.removeAttribute("aria-invalid"); err.hidden = true;
        const [y, m, d] = r.value!.split("-").map(Number);
        hint.textContent = `= ${toAd(cal, { y: y!, m: m!, d: d! })}`;
        moveFocus(input, 1);
        return;
      }

      const s = input.value.trim();
      if (s === "t" || s === "T") {
        input.value = fmt(todayBs()); input.removeAttribute("aria-invalid"); err.hidden = true;
        moveFocus(input, 1);
        return;
      }
      const rel = /^([+-])(\d+)$/.exec(s);
      if (rel) {
        const n = (rel[1] === "+" ? 1 : -1) * Number(rel[2]);
        const t = todayBs();
        if (t.d + n >= 1 && t.d + n <= 28) {
          input.value = fmt({ y: t.y, m: t.m, d: t.d + n });
          input.removeAttribute("aria-invalid");
          err.hidden = true;
          moveFocus(input, 1);
          return;
        }
      }
      let parts = s.split("-").filter(Boolean);
      if (parts.length === 1 && /^\d{8}$/.test(s)) parts = pattern === "YMD" ? [s.slice(0, 4), s.slice(4, 6), s.slice(6)] : [s.slice(0, 2), s.slice(2, 4), s.slice(4)];
      const n = parts.map(Number);
      if (!n.some(Number.isNaN) && (n.length === 3 || n.length === 2 || n.length === 1)) {
        let y: number, m: number, d: number;
        const t = todayBs();
        if (n.length === 1) { y = t.y; m = t.m; d = n[0]!; }
        else if (n.length === 2) { y = t.y; [m, d] = pattern === "YMD" ? [n[0]!, n[1]!] : [n[1]!, n[0]!]; }
        else { [y, m, d] = pattern === "YMD" ? [n[0]!, n[1]!, n[2]!] : [n[2]!, n[1]!, n[0]!]; }
        input.value = fmt({ y, m, d }); input.removeAttribute("aria-invalid"); err.hidden = true;
        moveFocus(input, 1);
        void loadCalendar().then(c => {
          cachedCal = c;
          hint.textContent = `= ${toAd(c, { y, m, d })}`;
        });
        return;
      }

      void loadCalendar().then(c => {
        cachedCal = c;
        const r = parseMiti(input.value, todayBs(), pattern, c);
        if (r.error) {
          input.setAttribute("aria-invalid", "true"); err.textContent = r.error; err.hidden = false; input.select();
          return;
        }
        input.value = r.value!; input.removeAttribute("aria-invalid"); err.hidden = true;
        const [y, m, d] = r.value!.split("-").map(Number);
        hint.textContent = `= ${toAd(c, { y: y!, m: m!, d: d! })}`;
        moveFocus(input, 1);
      });
    });
  });
});
